
import type { PropOptions } from 'vue';
import Vue from 'vue';
import ShareIcon from './images/share-icon.vue.svg';

// That component can't have button tag because it's used in Dropdown button
// and nested buttons are not allowed
export default Vue.extend({
  name: 'WarRoomShareButton',
  components: {
    ShareIcon,
  },
  props: {
    variant: {
      type: String,
      default: 'outline',
      validator: (value: string) => ['outline', 'borderless'].includes(value),
    } as PropOptions<string>,
  },
  computed: {
    rootClass(): string[] {
      return ['war-room-share-button', `war-room-share-button--${this.variant}`];
    },
  },
});
